import search from './search'
import employeeBookings from './employeeBookings'
import adminEmployee from './adminEmployee'
import adminDepartment from './adminDepartment'
import adminSpace from './adminSpace'
import adminNeighborhood from './adminNeighborhood'
export default {
  search,
  employeeBookings,
  adminEmployee,
  adminDepartment,
  adminSpace,
  adminNeighborhood,
}
